<script>
    import TutorialItem from "./TutorialItem.svelte";
</script>

<section class="tutorial">
    <h1 class="tutorial__title">Про Инсташпион</h1>
    <p class="tutorial__text">
        С помощью сервиса Инсташпион вы можете посмотреть, каким аккаунтам и на какие фотографии пользователь поставил лайк или написал комментарий, на кого подписался и от кого отписался, а также много другое. Так как сам Инстаграм* отключил функцию просмотра лайков у друзей, теперь Инсташпион является единственным оптимальным решением быстро проанализировать все лайки. Также вы можете собрать весь архив действий нужного пользователя или организовать постоянную слежку за его активностью.
    </p>
    <div class="tutorial__wrapper">

        <TutorialItem>
            <span slot="title">Начало наблюдения</span>
            <div slot="content">
                <TutorialItem isChild={true}>
                    <span slot="title">Добавление цели</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <p class="tutorial-subsection__text">
                                Чтобы добавить пользователя, за которым вы хотите следить (далее "Цель") - необходимо перейти в раздел “Добавить аккаунт”, который расположен в Меню или на Главной странице (или по <a href="/instashpion/dashboard/add-account">ссылке</a>)
                            </p>
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/01.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/01.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/01.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/02.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/02.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/02.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                            <p class="tutorial-subsection__text">
                                После чего вы попадете на страницу добавления Цели. Здесь в предоставленное поле необходимо написать логин вашей цели, после чего Инсташпион автоматически покажет результат поиска по всем пользователям Инстаграма*. Вам нужно только выбрать нужный аккаунт и кликнуть на него.
                            </p>
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/03.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/03.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/03.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                        </div>
                    </div>
                </TutorialItem>

                <TutorialItem isChild={true}>
                    <span slot="title">Анализ нескольких целей</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <p class="tutorial-subsection__text">
                                Вы можете добавить до 3 целей для слежки.
                                Если вы следите за несколькими целями, переключаться между ними можно на стрелки рядом с информацией о цели
                            </p>
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/04.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/04.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/04.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                        </div>
                    </div>
                </TutorialItem>

                <TutorialItem isChild={true}>
                    <span slot="title">Как следить за закрытым аккаунтом</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <p class="tutorial-subsection__text">
                                Вы можете добавить в качестве цели закрытый аккаунт, при этом на этапе добавления аккаунта у вас появится сообщение о необходимости добавления подписанного на цель аккаунта. То есть мониторинг активности будет вестись через аккаунт, подписанный на вашу цель.
                            </p>
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/05.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/05.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/05.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                            <p class="tutorial-subsection__text">
                                Если вы не можете быть подписаны на аккаунт цели собственным аккаунтом, то попробуйте зарегистрировать фейк-аккаунт и подписаться им на вашу цель. Или приобретите уже созданный аккаунт на одной из многочисленных бирж по продаже таких аккаунтов. После чего добавьте этот аккаунт на Инсташпион.
                                Обратите внимание, у аккаунта, который вы добавляете должна быть отключена двухфакторная аутентификация
                            </p>
                        </div>
                    </div>
                </TutorialItem>

                <TutorialItem isChild={true}>
                    <span slot="title">Результаты анализа</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <p class="tutorial-subsection__text">
                                После начала слежки за вашей Целью Инсташпиону потребуется некоторое время на сбор первичной информации со страницы вашей Цели (от нескольких минут до нескольких часов, в зависимости от размера аккаунта Цели).
                                Затем каждые сутки будет поступать обновленная информация о действиях в аккаунте вашей цели. Важно: не забывайте проверять и запускать очередной сбор данных по цели.
                                Полученная информация о вашей цели разделена по категориям:
                            </p>

                            <p class="tutorial-subsection__text">
                                В каждой категории собраны соответствующие события, расскажем о них подробнее:
                            </p>
                            <div class="tutorial-subsection__text">
                                <ul>
                                    <li>Лайки - в данной категории содержится информация о полученных и поставленных лайках.</li>
                                    <li>Комментарии - в данной категории содержится информация о полученных и оставленных комментариях.</li>
                                    <li>Подписки - новые подписки вашей цели - на кого он\она подписались.</li>
                                    <li>Подписчики - новые подписчики вашей цели - кто подписался на него\неё.</li>
                                    <li>Истории - содержит информацию по опубликованным историям вашей цели.</li>
                                    <li>Посты и Reels - новые публикации вашей цели.</li>
                                    <li>Поклонники - пользователи, которые взаимодействуют со страницей вашей цели, но не подписаны на него\неё.</li>
                                    <li>Чтобы Инсташпион продолжил собирать данные по вашей цели необходимо после завершения цикла сбора данных (24 часа) нажать на кнопку “Обновить”.</li>
                                </ul>
                            </div>
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/06.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/06.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/06.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                        </div>
                    </div>
                </TutorialItem>

                <TutorialItem isChild={true}>
                    <span slot="title">Прохождение верификации</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <p class="tutorial-subsection__text">
                                Верификация - процесс подтверждения пользователем наличия доступа к аккаунту, таким образом Инстаграм* может убедиться, что вы имеете доступ к аккаунту и действия совершаете именно вы.
                            </p>
                            <p class="tutorial-subsection__text">
                                Для пользователей Инсташпиона верификация может возникнуть только при добавлении собственного аккаунта для анализа приватного аккаунта.
                            </p>
                            <p class="tutorial-subsection__text">
                                Для того, чтобы обезопасить ваш аккаунт, Инстаграм* пришлет вам код на электронную почту или телефон, который привязан к инстаграм*-аккаунту.
                            </p>
                            <p class="tutorial-subsection__text">
                                Как правило, верификация возникает всегда при первом добавлении аккаунта на Инсташпион. В таком случае на странице сервиса появится блок с сообщением о том, что возникла необходимость пройти верификацию (также на вашу почту будет отправлено письмо от нашего сервиса, что он столкнулся с такой необходимостью).
                            </p>
                            <p class="tutorial-subsection__text">
                                В процессе работы и развития сервиса мы также выделили следующие способы противодействия Инстаграма* сервисам по продвижению (если вам попадется один из них - не волнуйтесь, это штатные ситуации, просто они немного сложнее обычной верификации):
                            </p>
                            <div class="tutorial-subsection__text">
                                <ul>
                                    <li>Круговые верификации (редко) - Инстаграм* будет раз за разом просить вас ввести код подтверждения, как правило от 3 до 8 раз, после чего доступ будет восстановлен и работа сервиса продолжится,</li>
                                    <li>Смена пароля (довольно редко) - бывают случаи, когда Инстаграм* просит пользователя сменить пароль на инстаграм*-аккаунте, так как подозревает, что вашим аккаунтом могли завладеть злоумышленники.</li>
                                    <li>Селфи-верификация (крайне редко) - новый тип верификации, который был замечен нами лишь несколько раз за всё время работы сервиса, однако имеет место быть. Он заключается в просьбе Инстаграма* выполнить несколько поворотов головы перед включенной селфи-камерой вашего смартфона. Инстаграм* не хранит эти данные и не ведет запись видео, это нужно чтобы алгоритмы удостоверились, что доступом к аккаунту владеет настоящий человек.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </TutorialItem>
            </div>
        </TutorialItem>

        <TutorialItem>
            <span slot="title">Тарифы и подписка</span>
            <div slot="content">
                <p class="tutorial-subsection__text">
                    На сервисе Инсташпион имеется широкая тарифная сетка, которая позволяет каждому пользователю выбрать оптимальный для него функционал за подходящую стоимость
                </p>
                <p class="tutorial-subsection__text">
                    Доступ к сервису предоставляется в формате подписки на один из тарифов сервиса. После завершения процедуры регистрации на сервис вам открывается доступ к Тестовому периоду, по истечении которого подписка продлевается автоматически на стандартный тариф 7 дней.
                </p>
                <p class="tutorial-subsection__text">
                    Отменить подписку можно в блоке Управление подпиской. Для этого нажмите на кнопку Управление подпиской на странице Тарифы.
                </p>
                <p class="tutorial-subsection__text">
                    Данные вашей карты передаются на сервер ЮКассы в зашифрованном виде. Безопасность платежей также обеспечивает международный стандарт PCI DSS: он включает 12 требований, которые разработаны Visa, MasterСard и другими платежными системами.
                </p>

                <TutorialItem isChild={true}>
                    <span slot="title">Тестовый период</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <p class="tutorial-subsection__text">
                                После завершения процедуры регистрации вам предоставляется тестовый период - 1 сутки за 1₽, в рамках которого вы получаете полный доступ к функционалу сервиса и его возможностям. После завершения тестового периода подписка продлевается автоматически.
                            </p>
                        </div>
                    </div>
                </TutorialItem>

                <TutorialItem isChild={true}>
                    <span slot="title">Недельный тариф</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <p class="tutorial-subsection__text">
                                Тариф активируемый по-умолчанию по завершению тестового периода со сроком доступа 7 дней и автоматическим продлением. В рамках тарифа у вас будет полный доступ к функционалу слежки за 3 целями.
                            </p>
                        </div>
                    </div>
                </TutorialItem>

                <TutorialItem isChild={true}>
                    <span slot="title">Оптовые тарифы</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <p class="tutorial-subsection__text">
                                В разделе Подписка, вы можете выбрать различные варианты тарифов, отличающиеся по сроку доступа:
                            </p>
                            <ul>
                                <li>На 1 месяц,</li>
                                <li>На 6 месяцев.</li>
                            </ul>
                            <p class="tutorial-subsection__text">
                                Обратите внимание, приобретая тариф на 6 месяцев, вы получаете дополнительную выгоду, т.к. оплачиваете меньшую стоимость, чем если бы вы были подключены на месячный тариф.
                            </p>
                        </div>
                    </div>
                </TutorialItem>
            </div>
        </TutorialItem>

        <TutorialItem>
            <span slot="title">Интерфейс личного кабинета</span>
            <div slot="content">
                <p class="tutorial-subsection__text">
                    Данный раздел поможет вам сориентироваться в интерфейсе личного кабинета и покажет, где искать все разделы и функции, которые вам могут понадобиться!
                </p>

                <TutorialItem isChild={true}>
                    <span slot="title">Верхнее меню (Шапка)</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/07.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/07.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/07.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                            <p class="tutorial-subsection__text">
                                Здесь находятся следующие элементы:
                            </p>
                            <ol>
                                <li>Назад - кнопка назад вернет вас на Дашборд, если вы находитесь на одной из внутренних страниц сервиса.</li>
                                <li>Название текущей странице - указывает на ваше местонахождение на сервисе.</li>
                                <li>Меню - отсюда вы можете попасть в дополнительные разделы:</li>
                            </ol>
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/08.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/08.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/08.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                            <p class="tutorial-subsection__text">
                                Здесь находятся следующие элементы:
                            </p>
                            <ol>
                                <li>Главная - вернет вас на Дашборд (главную страницу)</li>
                                <li>Добавить аккаунт - переход на страницу добавления новой цели,</li>
                                <li>Инструкция - переход в данную инструкцию по работе в Инсташпионе,</li>
                                <li>Тарифы и подписка - страница оплаты, выбора тарифа и отмены подписки,</li>
                                <li>Тех. поддержка - откроет виджет или страницу для связи с технической поддержкой сервиса,</li>
                                <li>Уведомления - переход на страницу настроек уведомлений,</li>
                                <li>Настройки - страница настроек, на которой вы можете поменять данные учетной записи на Инсташпионе и управлять добавленными целями,</li>
                                <li>Партнерская программа - переход к регистрации в партнерском кабинете,</li>
                                <li>Выход - куда же вы?</li>
                            </ol>
                        </div>
                    </div>
                </TutorialItem>

                <TutorialItem isChild={true}>
                    <span slot="title">Дашборд</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/09.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/09.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/09.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                            <ol>
                                <li>Цель - отображается аккаунт, данные которого сейчас представлены для просмотра,</li>
                                <li>Логин цели и данные цели - логин аккаунта, за которым происходит слежка,</li>
                                <li>Сменить аккаунт - переключение между всеми добавленными аккаунтами,</li>
                                <li>Данные выбранного аккаунта - показывают текущие показатели выбранного аккаунта,</li>
                                <li>Область обновления - здесь отображается данные о том, когда было сделано последнее обновление информации, кнопка “Обновить данные” - запускает новый цикл сбора информации о цели,</li>
                                <li>Область информации - здесь отображается вся получаемая информация об активности вашей цели.</li>
                            </ol>
                        </div>
                    </div>
                </TutorialItem>

                <TutorialItem isChild={true}>
                    <span slot="title">Страница Тарифы и подписка</span>
                    <div slot="content">
                        <div class="tutorial-subsection__body">
                            <div class="tutorial-subsection__img-wrapper">
                                <picture>
                                    <source srcset="/images/spy-tutorial/ru-RU/10.webp" type="image/webp">
                                    <source srcset="/images/spy-tutorial/ru-RU/10.png" type="image/png">
                                    <img src="/images/spy-tutorial/ru-RU/10.png" alt="" class="tutorial-subsection__image" />
                                </picture>
                            </div>
                            <ol>
                                <li>Блок информации - на данном блоке вы можете увидеть кол-во добавленных целей, оплаченный срок тарифа, название действующего тарифа, а также перейти к блоку управления подпиской.</li>
                                <li>Список тарифов - здесь вы можете выбрать интересующий вас тариф, а также увидеть уже подключенный тариф.</li>
                                <li>Оплата тарифа - для оплаты тарифа необходимо сначала выбрать интересующий вас тариф, кликнув на соответствующую карточку.</li>
                            </ol>
                        </div>
                    </div>
                </TutorialItem>

            </div>
        </TutorialItem>

        <TutorialItem>
            <span slot="title">Уведомления</span>
            <div slot="content">
                <p class="tutorial-subsection__text">
                    Вы можете настроить отправку уведомлений о новых событиях, замеченных Инсташпионом, в аккаунтах ваших целей.
                </p>
                <p class="tutorial-subsection__text">
                    Активировать отправку уведомлений можно странице <a href="/instashpion/dashboard/settings">Уведомления</a>.
                </p>

                <div class="tutorial-subsection__img-wrapper">
                    <picture>
                        <source srcset="/images/spy-tutorial/ru-RU/11.webp" type="image/webp">
                        <source srcset="/images/spy-tutorial/ru-RU/11.png" type="image/png">
                        <img src="/images/spy-tutorial/ru-RU/11.png" alt="" class="tutorial-subsection__image" />
                    </picture>
                </div>

                <p class="tutorial-subsection__text">
                    Здесь находятся следующие элементы:
                </p>
                <ol>
                    <li>Готовность данных - активируйте уведомление о завершении сбора и готовности очередного сбора, которое будет приходить на вашу эл.почту.</li>
                    <li>Отчет о событиях - при активации данного типа уведомлений, на вашу почту или в Телеграм будет приходит сводная информация о замеченных изменениях в аккаунте вашей цели. Вы можете выбрать периодичность таких уведомлений в зависимости от своих потребностей.</li>
                </ol>
                <p class="tutorial-subsection__text">
                    Настройка telegram-уведомлений. Вы можете получать уведомления о событиях через нашего telegram-бота!
                </p>
                <p class="tutorial-subsection__text">
                    Для этого активируйте тумблер “В Telegram” и следуйте инструкциям в появившемся блоке
                </p>
                <div class="tutorial-subsection__img-wrapper">
                    <picture>
                        <source srcset="/images/spy-tutorial/ru-RU/12.webp" type="image/webp">
                        <source srcset="/images/spy-tutorial/ru-RU/12.png" type="image/png">
                        <img src="/images/spy-tutorial/ru-RU/12.png" alt="" class="tutorial-subsection__image" />
                    </picture>
                </div>
            </div>
        </TutorialItem>

        <TutorialItem>
            <span slot="title">Дополнительно</span>
            <div slot="content">
                <p class="tutorial-subsection__text">
                    Над сервисом Инсташпион (и другими сервисами семейства Зен) работает большая команда менеджеров и разработчиков - мы постоянно находимся в поиске идей и тестировании гипотез, которые призваны помочь вам, нашим пользователям, более удобно взаимодействовать с нашими сервисами и получать максимально качественный функционал для ваших целей. Из-за большого количества постоянных обновлений и нововведений инструкция может быстро устаревать. Мы стараемся оперативно отмечать и вносить информацию обо всех обновлениях, но просим вас отнестись с пониманием, если вдруг вы видите в интерфейсе что-то чего еще нет в инструкции - скорее всего мы уже работает над этим.
                </p>
                <p class="tutorial-subsection__text">
                    Версия данной инструкции: от 1 июня 2022.
                </p>
            </div>
        </TutorialItem>


    </div>
</section>

<style>
    picture img {
        max-width: 360px;
        border-radius: 12px;
        border: 1px solid #161516;
    }
</style>